
import { Box } from "@mui/material"
import { havePermission } from "../../services/hoc/permissions"

import {LockPerson} from '@mui/icons-material'
import { useTranslation } from "react-multi-lang"
interface iProps {children:React.ReactElement,permission_key:string}
export default function PermissionBox ({children,permission_key}:iProps) {
const t = useTranslation()

    return (
        <>
        {
            havePermission(permission_key)? 
            children :
            <Box
            flexDirection={'column'}
            padding={'10px'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            boxShadow={'2px 2px 2px gray'}
            minHeight={'150px'}
            width={'100%'}
           
            >
                <LockPerson sx={{color:"gray"}}></LockPerson>
                <span style={{margin:'0 10px'}}>{t('no_view_permission')} </span>
            </Box>
        }

        </>
    )
}